import React from 'react';
import './Jogador.css';
import Campeonato from '../services/Campeonato';

export default props => {
  const { acompanhamento = false, idTime, jogador, versao, removerJogador, selecionarJogador, acaoAtiva = true } = props;
  const data = new Date(jogador.dataNasc);
  if (!jogador.nomeCompleto) jogador.nomeCompleto = '';
  const nomeCompleto = jogador.nomeCompleto.length > 21 ? `${jogador.nomeCompleto.substring(0, 20)}...` : jogador.nomeCompleto;
  const fotoTemp = require('../assets/jogadores/semfoto.svg');
  let fotoJogador;
  try {
    fotoJogador = require(`../assets/jogadores/fotos/${jogador.foto}`);
  } catch (e) {
    Campeonato.semFoto.push({ apelido: jogador.nome, nome: jogador.nomeCompleto, titulo: jogador.id });
    fotoJogador = null;
  }
  const foto = fotoJogador || fotoTemp;

  if (versao === 'Time') {
    return (
      <div className="JogadorTime">
        <div className="JogadorFoto">
          <div className="JogadorFotoImgTime">
            <img alt="Jogador" src={foto} height={146} width={110} />
          </div>
        </div>
        <div className="JogadorNomesTime">
          <span className="JogadorNome">
            <p>{jogador.nome}</p>
          </span>
          {/* <span className="JogadorNomeCompleto">
            <p>{jogador.nomeCompleto}</p>
          </span> */}
        </div>

        {acaoAtiva && !acompanhamento ? (
          <div className="RemoverJogador">
            <button onClick={() => removerJogador(idTime, jogador)}>X</button>
          </div>
        ) : null}
      </div>
    );
  } else {
    return (
      <div className="Jogador">
        <div className="JogadorFoto">
          <div className="JogadorFotoImg">
            <img alt="Jogador" src={foto} height="auto" width="auto" />
          </div>
        </div>
        <div className="JogadorNomes">
          <span className="JogadorNome">
            <p>{jogador.nome}</p>
          </span>
          <span className="JogadorNomeCompleto">
            <p>{nomeCompleto}</p>
          </span>
        </div>
        <div className="JogadorDivCategoria">
          <div className="JogadorDataNasc">
            <p>{`${data.getDate() + 1 < 10 ? '0' : ''}${data.getDate() + 1}/${data.getMonth() + 1 < 10 ? '0' : ''}${data.getMonth() +
              1}/${data.getFullYear()}`}</p>
          </div>
          <div className="JogadorCategoria">
            <p>{jogador.categoria}</p>
          </div>
        </div>
        <div className="SelecionarJogador">
          {acaoAtiva && !acompanhamento ? <button onClick={() => selecionarJogador(idTime, jogador)}>Sel.</button> : null}
        </div>
      </div>
    );
  }
};
